<template>
    <div class="container mt-3">
        <div class="row">
            <div class="col-md-12 mb-3">
                <button v-if="!viajemParada" class="btn btn-danger btn-block text-white btn-custom botaoInput" @click="openParada">Realizar Parada</button>
                <button v-else class="btn btn-success btn-block text-white btn-custom botaoInput" @click="retomarParada">Retomar Viajem</button>
            </div>
        </div>
        <div class="row justify-content-md-center" v-if="!viajemParada">
            <div class="col-md-6" v-for="(transporte, id) in transportes" :key="id">
                <div class="card text-center">
                    <div class="card-header">
                        <h5 class="text-success" v-if="transporte.final!=='1'">Transporte Ativo - <strong>{{ transporte.rastreio }}</strong></h5>
                        <h5 class="text-success" v-else>Transporte Finalizado - <strong>{{ transporte.rastreio }}</strong></h5>
                    </div>
                    <div class="card-body">
                        <p class="card-title text-muted textGeneral"><strong>Origem: </strong>{{ transporte.endereco_origem }}<a href="#" class="fas fa-map-marked-alt ml-2 text-info"></a></p>
                        <hr>
                        <p class="card-title text-muted textGeneral"><strong>Destino: </strong>{{ transporte.endereco_destino }}<a href="#" class="fas fa-map-marked-alt ml-2 text-info"></a></p>
                        <hr>
                        <p class="card-title text-muted textGeneral"><strong>Previsão de Entrega: </strong><span class="text-warning">{{ formatData(transporte.data_final) }}</span></p>
                        <hr>
                        <p class="card-text text-info textGeneral"><strong>Status Atual: </strong> {{ transporte.status }}</p>
                        <b-button @click="setStatus(id)" class="botaoInput" variant="outline-info" v-if="transporte.final!=='1'">Ir para: {{ transporte.next_status }}</b-button>
                    </div>
                    <div class="card-footer text-danger textGeneral" v-if="transporte.dias!=='0'">
                        Última Atualização: {{ transporte.dias }} dias atrás
                    </div>
                    <div class="card-footer text-danger textGeneral" v-else>
                        Última Atualização: Hoje
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL DE PARADA -->
        <b-modal id="modal-parada" hide-footer>
            <template v-slot:modal-title>
                Realizar Parada:
            </template>
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Motivo:" label-for="parada-titulo">
                        <b-input-group>
                            <b-form-select id="parada-titulo" :options="paradas" v-model="parada.titulo" 
                            :class="{ 'inputError': $v.parada.titulo.$error }"
                            class="textInput"
                            @keydown.tab="$v.parada.titulo.$touch"/>
                        </b-input-group>                        
                        <span class="error" v-if="!$v.parada.titulo.required && $v.parada.titulo.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="success" block class="mt-3 botaoInput" @click="setParada">Realizar Parada</b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-button variant="danger" block class="mt-3 botaoInput" @click="$bvModal.hide('modal-parada')">Cancelar</b-button>
                </div>
            </div>
        </b-modal>
    </div>

</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'motoristaRastreio',
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nome: '',
            level: '',
            email: '',
            razao: '',
            temp: {},
            transporte: {},
            transportes: [],
            ultimaAtualizacao: '',
            local: {},
            parada: {},
            paradas: [],
            viajemParada: false
        }
    },
    validations: {
        parada: {
            titulo: {
                required
            }
        }
    },
    methods: {
        setParada() {
            this.parada.motorista = this.nome

            axios['post'](`${baseApiUrl}/backend/log_paradas.php`, this.parada)
                .then((res) => {
                    this.temp.inicio = res.data['inicio']

                    // MOTORISTA (MOTORISTA)
                    const tipo2 = `?tipo=inicioParadaMotorista`
                    const destinoEmail2 = `&destinoEmail=${this.email}`
                    const destinoNome2 = `&destinoNome=${this.nome}`
                    const parada2 = `&parada=${this.parada.titulo}`
                    const inicio2 = `&inicio=${this.temp.inicio}`
                    axios.get(`${baseApiUrl}/backend/mailMotorista.php
                        ${tipo2}${destinoEmail2}${destinoNome2}${parada2}${inicio2}`).then(() => {})

                    this.$toasted.global.defaultSuccess({ message : 'Log inserido com sucesso!' })
                    this.$bvModal.hide('modal-parada')
                    this.parada = {}
                    this.viajemParada = true
                })
                .catch(
                    (e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                }
            )
        },
        retomarParada() {
            this.parada.motorista = this.nome

            axios['post'](`${baseApiUrl}/backend/retorna_log_paradas.php`, this.parada)
                .then((res) => {
                    this.temp.final = res.data['final']
                    this.temp.parada = res.data['parada']

                    // MOTORISTA (MOTORISTA)
                    const tipo2 = `?tipo=finalParadaMotorista`
                    const destinoEmail2 = `&destinoEmail=${this.email}`
                    const destinoNome2 = `&destinoNome=${this.nome}`
                    const parada2 = `&parada=${this.temp.parada}`
                    const final2 = `&final=${this.temp.final}`
                    axios.get(`${baseApiUrl}/backend/mailMotorista.php
                        ${tipo2}${destinoEmail2}${destinoNome2}${parada2}${final2}`).then(() => {})

                    this.$toasted.global.defaultSuccess({ message : 'Log inserido com sucesso!' })
                    this.parada = {}
                    this.viajemParada = false
                })
                .catch(
                    (e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                }
            )
        },
        openParada() {
            this.$bvModal.show('modal-parada')
        },
        loadParadas() {
            const url = `${baseApiUrl}/backend/paradas.php`
            axios.get(url).then(res => {
                this.paradas = res.data.map(parada => {
                    return { ...parada, value: parada.titulo, text: parada.titulo }
                })
            })
        },
        setStatus(id) {
            this.transporte = this.transportes[id]
            this.local.transporte = this.transporte.rastreio
            this.local.status = this.transporte.next_status

            axios['post'](`${baseApiUrl}/backend/log_transportes.php`, this.local)
                .then(() => {
                        
                    // DESTINO (CLIENTE)
                    const tipo1 = `?tipo=novoStatusCliente`
                    const destinoEmail1 = `&destinoEmail=${this.transporte.email_destino}`
                    const destinoNome1 = `&destinoNome=${this.transporte.destino}`
                    const rastreio1 = `&rastreio=${this.transporte.rastreio}`
                    const status1 = `&status=${this.transporte.next_status}`
                    axios.get(`${baseApiUrl}/backend/mailCliente.php
                        ${tipo1}${destinoEmail1}${destinoNome1}${rastreio1}${status1}`).then(() => {})

                    // ORIGEM (CLIENTE)
                    const tipo2 = `?tipo=novoStatusCliente`
                    const destinoEmail2 = `&destinoEmail=${this.transporte.email_origem}`
                    const destinoNome2 = `&destinoNome=${this.transporte.origem}`
                    const rastreio2 = `&rastreio=${this.transporte.rastreio}`
                    const status2 = `&status=${this.transporte.next_status}`
                    axios.get(`${baseApiUrl}/backend/mailCliente.php
                        ${tipo2}${destinoEmail2}${destinoNome2}${rastreio2}${status2}`).then(() => {})

                    // MOTORISTA (MOTORISTA)
                    const tipo3 = `?tipo=novoStatusMotorista`
                    const destinoEmail3 = `&destinoEmail=${this.email}`
                    const destinoNome3 = `&destinoNome=${this.nome}`
                    const rastreio3 = `&rastreio=${this.transporte.rastreio}`
                    const status3 = `&status=${this.transporte.next_status}`
                    axios.get(`${baseApiUrl}/backend/mailMotorista.php
                        ${tipo3}${destinoEmail3}${destinoNome3}${rastreio3}${status3}`).then(() => {})

                    // RESPONSAVEL (FUNCIONARIO)
                    const tipo4 = `?tipo=novoStatusFuncionario`
                    const destinoEmail4 = `&destinoEmail=${this.transporte.email_responsavel}`
                    const destinoNome4 = `&destinoNome=${this.transporte.responsavel}`
                    const rastreio4 = `&rastreio=${this.transporte.rastreio}`
                    const status4 = `&status=${this.transporte.next_status}`
                    axios.get(`${baseApiUrl}/backend/mailFuncionario.php
                        ${tipo4}${destinoEmail4}${destinoNome4}${rastreio4}${status4}`).then(() => {})

                    this.$toasted.global.defaultSuccess({ message : 'Log inserido com sucesso!' })
                    this.loadTransportes()
                })
                .catch(
                    (e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                }
            )
        },
        loadTransportes() {
            const url = `${baseApiUrl}/backend/transportesByMotorista.php?motorista=${this.nome}`
            axios.get(url).then(res => {
                this.transportes = res.data
            })
        },
        loadStatusParada() {
            const url = `${baseApiUrl}/backend/get_paradas.php?motorista=${this.nome}`
            axios.get(url).then(res => {
                if(res.data['dados']==='parado'){
                    this.viajemParada = true
                }else{
                    this.viajemParada = false
                }
            })
        },
        formatData(data) {
            const arr = data.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
                this.razao = decodedToken['data'].razao
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level !== 'motorista') {
            this.$router.push('/')
        }
        this.loadTransportes()
        this.loadParadas()
        this.loadStatusParada()
    }
}
</script>

<style>
    .botaoInput {
        font-size: 0.8rem !important;
        border-radius: 0px !important;
    }

    .textGeneral {
        font-size: 0.8rem;
    }

    .textInput {
        border: 1px solid rgb(220, 220, 220);
        outline: 0 !important;
        border-radius: 0px !important;
        background-color: transparent !important;
        font-size: 0.8rem !important;
    }
</style>